module.exports = __webpack_public_path__ + "static/media/wallpaper.eee53fc7.jpg";